import { MeshGroup } from "@/3d/meshGroup/MeshGroup";
import React from "react";
import { Vector3 } from "three";

type MeshGroupMeshSettingsProps = {
    group: MeshGroup;
    onChange: (group: MeshGroup) => void;
};

export const MeshGroupMeshSettings = ({ group, onChange }: MeshGroupMeshSettingsProps) => {
    const handlePositionChange = (meshName: string, axis: "x" | "y" | "z", value: number) => {
        const newPosition = new Vector3().copy(group.meshPositions[meshName]);
        newPosition[axis] = value;

        onChange({
            ...group,
            meshPositions: {
                ...group.meshPositions,
                [meshName]: newPosition,
            },
        });
    };

    const handleRotationChange = (meshName: string, axis: "x" | "y" | "z", value: number) => {
        const newRotation = new Vector3().copy(group.meshRotations[meshName]);
        newRotation[axis] = value;

        onChange({
            ...group,
            meshRotations: {
                ...group.meshRotations,
                [meshName]: newRotation,
            },
        });
    };

    return (
        <div className="d-flex flex-column gap-3">
            {group.meshNames.map((meshName) => (
                <div key={meshName} className="card p-3">
                    <div className="fw-bold mb-2">{meshName}</div>

                    <div className="mb-3">
                        <div className="mb-2">Position</div>
                        <div className="d-flex gap-2">
                            {(["x", "y", "z"] as const).map((axis) => (
                                <div key={axis} className="flex-grow-1">
                                    <label className="form-label">{axis.toUpperCase()}</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={group.meshPositions[meshName][axis]}
                                        onChange={(e) =>
                                            handlePositionChange(
                                                meshName,
                                                axis,
                                                parseFloat(e.target.value)
                                            )
                                        }
                                        step={0.1}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>

                    <div>
                        <div className="mb-2">Rotation</div>
                        <div className="d-flex gap-2">
                            {(["x", "y", "z"] as const).map((axis) => (
                                <div key={axis} className="flex-grow-1">
                                    <label className="form-label">{axis.toUpperCase()}</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={group.meshRotations[meshName][axis]}
                                        onChange={(e) =>
                                            handleRotationChange(
                                                meshName,
                                                axis,
                                                parseFloat(e.target.value)
                                            )
                                        }
                                        step={0.1}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};
